import { render, staticRenderFns } from "./dangerMasterEtc.vue?vue&type=template&id=418cf2ce"
import script from "./dangerMasterEtc.vue?vue&type=script&lang=js"
export * from "./dangerMasterEtc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('418cf2ce')) {
      api.createRecord('418cf2ce', component.options)
    } else {
      api.reload('418cf2ce', component.options)
    }
    module.hot.accept("./dangerMasterEtc.vue?vue&type=template&id=418cf2ce", function () {
      api.rerender('418cf2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerMasterEtc.vue"
export default component.exports